import { Component, computed, input, InputSignal, Signal, ChangeDetectionStrategy } from '@angular/core';
import { ProductModel } from '@libs/shop/models';
import { ProductCardComponent } from '../../catalog/product-card/product-card.component';

@Component({
  selector: 'ui-product-bundles-list',
  styleUrls: ['./product-bundles-list.component.scss'],
  templateUrl: './product-bundles-list.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    ProductCardComponent,
  ],
})
export class ProductBundlesListComponent {
  public products: InputSignal<ProductModel[]> = input.required();

  public mappedProducts: Signal<ProductModel[]> = computed(() => this.products().map((product: ProductModel) => {
    return {
      ...product,
      actionType: 'show-product',
    };
  }));
}
